import { FC, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface CustomAccordionProps {
  label: string;
  children: React.ReactNode;
  defaultOpen?: boolean; // Optional: Start with the accordion open
}

const CustomAccordion: FC<CustomAccordionProps> = ({
  label,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => setIsOpen((prev) => !prev);

  return (
    <div className="border border-gray-3 rounded-lg">
      <div
        className="flex justify-between items-center py-2 px-3 cursor-pointer bg-gray-1 hover:bg-gray-2"
        onClick={toggleAccordion}
      >
        <span className="font-medium text-lg">{label}</span>

        {isOpen ? (
          <FiChevronUp className="w-5 h-5 text-gray-600" />
        ) : (
          <FiChevronDown className="w-5 h-5 text-gray-600" />
        )}
      </div>

      {isOpen && <div className="py-4 px-3 bg-white">{children}</div>}
    </div>
  );
};

export default CustomAccordion;
